import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const style = {
	Wrapper : styled.div`
    display : flex;
    align-items : center;
    justify-content : center;
    width : 100%;
    height : 100%;
  `,
	Loading: styled.div`
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: ${rotate360} 2s linear infinite;
	`,
};

export default function Loading({ ...props }) {
	return (
		<style.Wrapper>
			<style.Loading {...props} />
		</style.Wrapper>
	);
}